<div class="header">{{header}} 
    <app-info-button *ngIf="infoButton" [linkArray]="infoButton.linkArray" [title]="infoButton.infoTitle"></app-info-button>
</div>
<div class="body">
    <ng-content></ng-content>
</div>